import React from "react";
import googleBuss from "../../assets/images/logos/google-buss.svg";
import vrboImage from "../../assets/images/logos/vrbo.svg";
import agodaImage from "../../assets/images/logos/agoda.svg";
import airbnbImage from "../../assets/images/logos/airbnb.svg";
import bookingImage from "../../assets/images/logos/booking.svg";
import tripAdvisorImage from "../../assets/images/logos/trip-advisor.png";
import mmtImage from "../../assets/images/logos/mmt.svg";

const logos = [
  { src: airbnbImage,      alt: "Airbnb" },
  { src: tripAdvisorImage, alt: "TripAdvisor" },
  { src: googleBuss,       alt: "Google Business" },
  { src: vrboImage,        alt: "VRBO" },
  { src: agodaImage,       alt: "Agoda" },
  { src: bookingImage,     alt: "Booking.com" },
  { src: mmtImage,         alt: "MakeMyTrip" },
];

const IndustryLeaders = () => {
  // Duplicate so the strip loops seamlessly
  const track = [...logos, ...logos];

  return (
    <section className="tw-py-12 tw-bg-white tw-border-y tw-border-slate-100 tw-overflow-hidden">


      {/* Marquee track */}
      <div
        className="tw-relative tw-flex tw-overflow-hidden"
        style={{
          /* Fade edges to white */
          maskImage:
            "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
        }}
      >
        <div className="marquee-track">
          {track.map((logo, i) => (
            <div key={i} className="marquee-item">
              <div className="marquee-logo-box">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="marquee-logo"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryLeaders;
